import globalStore from "@/core/store/globalStore";
import { Department, User } from "@/domain/user";
import {
	INSTALLER_EQUIPMENT_REPORT_DEPARTMENTS,
	isUserInDepartmentsByName,
} from "@/shared/lib/findDepartmentIdByName";

// Название департамента относится к его id
const Departments = {
	ExecutionDivision: 11,
	SupplyDivision: 12,
	DeveloperDivision: 1,
	TechDivison: 2,
	Administrators: 9,
} as const;

type DepartmentId = (typeof Departments)[keyof typeof Departments];

const DepartmentAccessMap = {
	RO: [Departments.ExecutionDivision, Departments.SupplyDivision] as const,
	InstallerSchedule: [
		Departments.ExecutionDivision,
		Departments.SupplyDivision,
		Departments.DeveloperDivision,
		Departments.Administrators,
	] as const,
	PasswordFunc: [
		Departments.ExecutionDivision,
		Departments.TechDivison,
		Departments.DeveloperDivision,
		Departments.Administrators,
	]
} as const;

type AccessType = keyof typeof DepartmentAccessMap;

const checkUserInDepartments = (currentUser: User, departments: readonly DepartmentId[]) => {
	return departments.some((id) => currentUser.department_ids.includes(id));
};

export function userIsAdmin(currentUser: User): boolean {
	return Object.values(currentUser.permissions).every((value) => value);
}

export function isEvgenyBorodyn(currentUser: User): boolean {
	return currentUser.id === 57;
}

export function hasAccess(accessType: AccessType): boolean {
	const currentUser = globalStore.getters.getCurrentUserInfo as User;
	const isAdmin = userIsAdmin(currentUser);
	if (isAdmin) return true;

	if (isEvgenyBorodyn(currentUser)) return true;

	const allowedDepartments = DepartmentAccessMap[accessType];
	return checkUserInDepartments(currentUser, allowedDepartments);
}

export function getStatusAccessForRO(): boolean {
	return hasAccess("RO");
}

export function getStatusAccessForInstallerSchedule(): boolean {
	return hasAccess("InstallerSchedule");
}

export function getStatusAccessForPasswordFunc(): boolean{
	return hasAccess("PasswordFunc");
}

export function getStatusAccessForInstallerEquipmentReport(): boolean {
	const currentUser = globalStore.getters.getCurrentUserInfo as User | undefined;
	const departments = globalStore.getters.getDepartments as Department[];

	return isUserInDepartmentsByName(
		currentUser?.department_ids,
		INSTALLER_EQUIPMENT_REPORT_DEPARTMENTS,
		departments,
	);
}
